import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IBaseDto } from '@http/clients/reporting-app/base-dto.service';
import { DepartmentService } from '@http/clients/reporting-app/department.service';
import { ReportsService } from '@services/reports.service';
import { CustomMenuItemComponent } from '@shared/custom-menu-item/custom-menu-item.component';
import { EditorComponentBase, GenericDropdownMultiselectComponent } from 'ngx-lib';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-reporting-department-editor',
    templateUrl: './reporting-department-editor.component.html',
    styleUrls: ['./reporting-department-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownMultiselectComponent, CustomMenuItemComponent]
})
export class ReportingDepartmentEditorComponent
    extends EditorComponentBase<number[] | null>
    implements OnInit, OnDestroy
{
    items: IBaseDto[];
    selectedItems?: IBaseDto[];
    subscription?: Subscription;

    constructor(
        private readonly reportingDepartmentService: DepartmentService,
        private readonly reportsService: ReportsService
    ) {
        super();
        this.items = [];
    }

    async ngOnInit(): Promise<void> {
        this.items = await this.reportingDepartmentService.getAll();
        this.subscription = this.reportsService.selectedProperty$.subscribe(async (ready) => {
            if (
                ready &&
                this.bindingProperty !== null &&
                this.bindingProperty?.length &&
                Array.isArray(this.bindingProperty)
            ) {
                const inactiveIds = this.bindingProperty.filter((id) => !this.items?.some((obj) => obj['id'] === id));
                if (inactiveIds.length > 0) {
                    const archivedItems = await this.reportingDepartmentService.getByIds(inactiveIds);
                    this.items = [...(this.items || []), ...archivedItems];
                }
                this.selectedItems = this.items.filter(
                    (obj) => this.bindingProperty?.find((id) => id === obj['id']) !== undefined
                );
            } else if (ready && (this.bindingProperty === null || this.bindingProperty === undefined)) {
                this.selectedItems = [];
            }
        });
    }

    onSelectedItemsChange() {
        if (this.selectedItems?.length) {
            this.bindingProperty = this.selectedItems.map((obj) => obj.id);
        } else {
            this.bindingProperty = null;
        }
        this.valueChange.emit();
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
